import React, { Fragment, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import NavigationLinks from './NavigationLinks';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

function AppNavigation() {
  const classes = useStyles();
  const [isNavDrawerOpen, setIsNavDrawerOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <Fragment>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={() => setIsNavDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Elder Scrolls Legends
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={isNavDrawerOpen} onClose={() => setIsNavDrawerOpen(false)}>
        <NavigationLinks openDialog={handleOpenDialog} />
      </Drawer>
      <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={isDialogOpen}>
        <DialogTitle>About the Project</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The goal of this project is to build a visually appealing, modern responsive front end
            application. The application connects into the Elder Scrolls Legends API for data
            retrieval. Users are then able to infinitely scroll through the card data and fuzzy
            search by card names.
            <br />
            <br />
            This application was built with React using Create React App. State management and data
            retrieval with React Hooks. The user interface is built with the React Material UI
            framework and deployed on Netlify.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default AppNavigation;
